import { render, staticRenderFns } from "./CargoTransaction.vue?vue&type=template&id=23a26ed8&"
import script from "./CargoTransaction.vue?vue&type=script&lang=js&"
export * from "./CargoTransaction.vue?vue&type=script&lang=js&"
import style0 from "./CargoTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoTransaction.vue"
export default component.exports